import PropTypes from 'prop-types';
import React from 'react';
import ChipInput from 'shared/vendor/material-ui-chip-input/src/ChipInput';
import _ from 'lodash';
import AutoComplete from 'material-ui/AutoComplete/AutoComplete';
import {FIELD_WIDTH} from '../consts';
import AbstractListerField from './AbstractListerField';

export default class ListerMultiSelect extends AbstractListerField {
  handleMultiSelectFieldChange = (attributeName, checked) => {
    const {onChange, value} = this.props;
    const newValue = checked ? _.union(value, [attributeName]) : _.without(value, attributeName);
    onChange(newValue);
  };

  render() {
    const {dataSet, freeText, id} = this.props;
    let {value} = this.props;
    if (_.isString(value)) {
      value = [value];
    }
    return (
      <ChipInput
        id={id}
        onRequestAdd={chip => {
          this.handleMultiSelectFieldChange(chip, true);
        }}
        onRequestDelete={chip => {
          this.handleMultiSelectFieldChange(chip, false);
        }}
        dataSource={_.uniq(_.concat(_.keys(dataSet), value || []))}
        style={{width: '70%'}}
        filter={AutoComplete.caseInsensitiveFilter}
        hintText={freeText ? 'Start typing or enter your own' : 'Select from list'}
        openOnFocus
        fullWidth
        newChipKeyCodes={[13, 188, 186]}
        value={value || []}
        {..._.pick(this.props, [
          'onFocus',
          'onBlur',
          'disabled',
          'floatingLabelText',
          'orderBy',
          'errorStyle',
          'errorText',
        ])}
      />
    );
  }
}

ListerMultiSelect.propTypes = {
  onChange: PropTypes.func,
  floatingLabelText: PropTypes.string,
  orderBy: PropTypes.shape({
    iteratees: PropTypes.array,
    orders: PropTypes.array,
  }),
  required: PropTypes.bool,
  freeText: PropTypes.bool,
  width: PropTypes.oneOf([FIELD_WIDTH.FULL]),
};

ListerMultiSelect.defaultProps = {
  width: FIELD_WIDTH.FULL,
};
